import { PartialTranslation } from '../translations';

export const rw: PartialTranslation = {
  newChat: 'Ikiganiro gishya',
  search: 'Shakisha',
  user: 'Ukoresha',
  settings: 'Amagenamiterere',
  language: 'Ururimi',
  getHelp: 'Gira ubufasha',
  viewAllPlans: 'Reba gahunda zose',
  learnMore: 'Menya byinshi',
  logOut: 'Gusohoka',
  chooseLanguage: 'Hitamo ururimi',
  chooseYourPreferredLanguage: 'Hitamo ururimi ukunda',
  searchLanguages: 'Shakisha indimi...',
  autoDetect: 'Gukora mu buryo bwikora',
  noLanguagesFound: 'Nta ndimi zabonetse',
  askAnything: 'Baza ikintu icyo ari cyo cyose',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Bwite',
  freePlan: 'Gahunda y\'ubuntu',
  current: 'Ubu',
  close: 'Funga',
  archive: 'Bika mu bubiko',
  delete: 'Gusiba',
  confirmDelete: 'Uzi neza ko ushaka gusiba iki kiganiro?',
  confirmArchive: 'Uzi neza ko ushaka kubika iki kiganiro mu bubiko?',
  deleteCannotUndo: 'Iki gikorwa ntikishobora gusubizwa inyuma.',
  archiveCanFind: 'Nyuma yo kubibika, ushobora kubisanga mu rutonde rw\'ububiko.',
  // 资源面板
  resources: 'Ibikoresho',
  addResource: 'Ongeraho ikinyabiziga',
  deleteResource: 'Siba ikinyabiziga',
  noMatchingResourcesFound: 'Nta bikoresho bihuye bibonetse',
  noResourcesAvailable: 'Nta bikoresho bihari',
  hideResources: 'Hisha ibikoresho',
  showResources: 'Erekana ibikoresho',
  
  // 聊天输入框
  typeMessage: 'Wandika ubutumwa...',
  thinkingOptions: 'Amahitamo yo gutekereza',
  deleteFile: 'Siba dosiye',
  clearSelection: 'Siba ibyo uhisemo',
  
  // 思考模式选项
  deepInsight: 'Ubwenge bwimbitse · Isesengura ryo hejuru',
  deepInsightDesc: 'Gusobanukirwa vuba ingingo zingenzi',
  deepExploration: 'Ubushakashatsi bwimbitse · Isesengura ryuzuye',
  deepExplorationDesc: 'Ubushakashatsi bwimbitse bw\'impande nyinshi',
  deepDeconstruction: 'Gusesa neza · Impaka zifatika',
  deepDeconstructionDesc: 'Isesengura ritera imbere',
  
  // 写作模式选项
  contractReview: 'Gusuzuma amasezerano · Kumenya ingaruka',
  contractReviewDesc: 'Isesengura ry\'ingingo n\'igenzura ry\'ubwishyu',
  textPolish: 'Gutunganya inyandiko · Imvugo y\'umwuga',
  textPolishDesc: 'Guteza imbere ururimi n\'imiterere',
  legalDocuments: 'Inyandiko z\'amategeko · Kwandika bisanzwe',
  legalDocumentsDesc: 'Kwandika inyandiko z\'amategeko mu buryo bw\'umwuga',
  addAttachment: 'Ongeraho inyandiko',
  sendMessage: 'Ohereza Ubutumwa',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Log in',
  register: 'Sign up',
  welcomeBack: 'Welcome to LawHelper',
  loginSubtitle: 'Your AI Legal Research Assistant',
  continueWithGoogle: 'Continue with Google',
  continueWithMicrosoft: 'Continue with Microsoft',
  continueWithWeChat: 'Continue with WeChat',
  orContinueWith: 'or continue with',
  emailTab: 'Email',
  phoneTab: 'Phone',
  emailPlaceholder: 'Enter your email',
  phonePlaceholder: 'Enter phone number',
  codePlaceholder: 'Enter 6-digit code',
  sending: 'Sending...',
  verifying: 'Verifying...',
  verify: 'Verify',
  sendMagicLink: 'Send Magic Link',
  getVerificationCode: 'Get Code',
  resendCode: 'Resend Code',
  resendIn: 'Resend in',
  magicLinkSent: 'Magic link sent to your email',
  magicLinkHint: 'We will send a secure link to your email',
  otpSent: 'Verification code sent',
  agreeToTerms: 'By continuing, you agree to our',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  and: 'and',
  privacyTitle: 'Your Privacy Matters',
  privacyIntro: 'We use cookies and similar technologies to provide you with the best experience. You can customize your preferences below.',
  essentialCookies: 'Essential Cookies',
  essentialDesc: 'Required for the website to function',
  analyticsCookies: 'Analytics Cookies',
  analyticsDesc: 'Help us improve our service',
  marketingCookies: 'Marketing Cookies',
  marketingDesc: 'Used for personalized content',
  acceptAll: 'Accept All',
  essentialOnly: 'Essential Only',
  customize: 'Customize',
  savePreferences: 'Save Preferences',
  back: 'Back',
  readPrivacyPolicy: 'Read our Privacy Policy',
  cookiePolicy: 'Cookie Policy',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL (Personal Information Protection Law)',

  // AI工具面板
  aiReview: 'AI Review',
  aiDraft: 'AI Draft',
  smartAssistant: 'Template',

  // 知识库搜索
  enableKnowledgeSearch: 'Enable Knowledge Base Search',
  knowledgeSearchDesc: 'AI prioritizes searching from your documents',
  clickToDisable: 'Click to disable',
  clickToEnable: 'Click to enable',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Igisubizo cyihuse',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Hagarika',
  library: 'Isomero',
  filterAll: 'Byose',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Aratekereza...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'Rusange',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'Ku byerekeye',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Umufasha wa inyandiko za AI',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Ikosa',
  unknownError: 'Unknown error',
  file: 'Idosiye',
  loading: 'Birakuriwe...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'Isesengura rya AI',
};
